/**
 * @abstract
 */
export class Animation
{
	start(): Promise
	{

	}

	finish(node: Element, onFinish: ?Function)
	{

	}
}